import { useShallow } from 'zustand/react/shallow';

import { USER_AGENT_DEV_MODE_TOKEN } from '~/constants';
import { useAppInfoStore } from '~/store';

/**
 * @description 라우트 Guard에서 사용하는 앱 실행 환경 정보
 * - bridgeStatus: 네이티브 브릿지 응답 상태 (pending/done/failed)
 * - isWebView: appType 기준 웹뷰 여부
 * - isDevMode: 개발 모드 User-Agent 여부 (브릿지 없이 웹뷰처럼 동작)
 */
export const useAppEnv = () => {
  const { appType, bridgeStatus } = useAppInfoStore(
    useShallow((state) => ({ appType: state.appType, bridgeStatus: state.bridgeStatus }))
  );

  const isDevMode = navigator.userAgent === USER_AGENT_DEV_MODE_TOKEN;
  const isWebView = appType === 'ios' || appType === 'android';

  return { bridgeStatus, isWebView, isDevMode };
};
